import { ActivityLogType } from "../../../../../../../../utils/constants";
import { CustomLogTypography } from "./utils";

export default function getScanOrUserLogContent(log) {
  if (log.log_type === ActivityLogType.CONTROL_EXCLUDED)
    return (
      <CustomLogTypography>Control excluded from analysis</CustomLogTypography>
    );

  if (log.log_type === ActivityLogType.CONTROL_INCLUDED)
    return (
      <CustomLogTypography>Control no longer excluded</CustomLogTypography>
    );
}
